module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "vbl-form",
    attrs: {
      "data-vv-scope": _vm.formName
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._t("default"), _vm._l((_vm.validate), function(item, name) {
    return _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.rules),
        expression: "item.rules"
      }],
      key: name,
      attrs: {
        "type": "hidden",
        "name": name,
        "data-vv-as": item.desc,
        "data-vv-validate-on": "none"
      },
      domProps: {
        "value": (item.key && _vm.value[name]) ? _vm.value[name][item.key] : _vm.value[name]
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b91fb8a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblForm/src/vblForm.vue
// module id = 289
// module chunks = 0